/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hakkimizda_S3_Item4Inputs */

const tr_hakkimizda_s3_item4 = /** @type {(inputs: Hakkimizda_S3_Item4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QNB eSolutions e-Arşiv / e-Fatura entegrasyonu (UBL-TR 2026)`)
};

const en_hakkimizda_s3_item4 = /** @type {(inputs: Hakkimizda_S3_Item4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QNB eSolutions e-Arşiv / e-Fatura integration (UBL-TR 2026)`)
};

const de_hakkimizda_s3_item4 = /** @type {(inputs: Hakkimizda_S3_Item4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QNB eSolutions e-Arşiv / e-Fatura Integration (UBL-TR 2026)`)
};

const ru_hakkimizda_s3_item4 = /** @type {(inputs: Hakkimizda_S3_Item4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Интеграция QNB eSolutions e-Arşiv / e-Fatura (UBL-TR 2026)`)
};

/**
* | output |
* | --- |
* | "QNB eSolutions e-Arşiv / e-Fatura integration (UBL-TR 2026)" |
*
* @param {Hakkimizda_S3_Item4Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const hakkimizda_s3_item4 = /** @type {((inputs?: Hakkimizda_S3_Item4Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hakkimizda_S3_Item4Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hakkimizda_s3_item4(inputs)
	if (locale === "de") return de_hakkimizda_s3_item4(inputs)
	if (locale === "ru") return ru_hakkimizda_s3_item4(inputs)
	return tr_hakkimizda_s3_item4(inputs)
});